/**
 * Clock port — injected time.
 *
 * WHY: no ad-hoc `Date.now()` anywhere. A single injected clock makes tests
 * deterministic and underpins ordered events / replay.
 */
export interface Clock {
  /** Current time as UTC epoch milliseconds. */
  now(): number;
}

/** Real wall-clock adapter for production. The one sanctioned use of Date.now(). */
export const systemClock: Clock = {
  // eslint-disable-next-line no-restricted-properties -- the single adapter boundary for wall-clock time
  now: () => Date.now(),
};
